<div class="mct-flex mct-col mct-gap-32">
  <h2>{{ 'revenue.post-transactions.title' | translate | titlecase }}</h2>

  <div>
    <wl-post-transactions-request-search
      #profileChangeRequestSearch
      [(searchParams)]="searchQueryParams"
      (selectedAccountingPackageId)="accountingPackageChanged($event)"
      (displayPackageWarning)="checkForValidPackage($event)"
    ></wl-post-transactions-request-search>
    <div class="button-container mt-27">
      <button
        pButton
        type="button"
        class="atlas-btn atlas-btn-primary"
        (click)="previewTransactionsClicked()"
        [disabled]="displayWarning || isSearching"
      >
        <wl-busy [show]="isSearching"></wl-busy>
        @if (!isSearching) {
          {{ 'revenue.post-transactions.preview' | translate | titlecase }}
        }
        @if (isSearching) {
          {{ 'common.searching' | translate | titlecase }}
        }
      </button>
    </div>
  </div>
  <div>
    <a (click)="viewDetailsClicked()" *ngIf="!displayWarning">{{ 'revenue.post-transactions.view-details' | translate | titlecase }} </a>
  </div>
  <div *ngIf="showSummary">
    <wl-post-transactions-summary
      [transactionSummaries]="transactionSummaries"
      (exportSummariesClicked)="exportSummariesClicked()"
      (exportDetailsClicked)="exportDetailsClicked()"
      [exportingDetails]="exportingDetails"
      [exportingSummaries]="exportingSummaries"
      [accountingPackageId]="searchQueryParams.AccountingPackageID"
    ></wl-post-transactions-summary>
    <div class="mt-5 mct-flex mct-row mct-justify-start mct-items-end mct-gap-10">
      <div [hidden]="!showIntacctFields">
        <label class="light-text">{{ 'revenue.post-transactions.journal' | translate | ucfirst }}</label>
        <p-select
          appendTo="body"
          name="intacctLocation"
          [options]="intacctJournals"
          [(ngModel)]="postExistingTransactionDto.IntacctJournalId"
          showClear
          [placeholder]="'revenue.post-transactions.intacct-journal-placeholder' | translate | titlecase"
          [style]="{ width: '100%' }"
        ></p-select>
      </div>
      <button
        [disabled]="disablePostingButton || readOnlyAccess"
        class="atlas-btn atlas-btn-primary mt-5"
        (click)="postTransactionsClicked()"
      >
        <wl-busy [show]="isPosting"></wl-busy>
        <span> {{ 'revenue.post-transactions.post-transactions' | translate | uppercase }}</span>
      </button>
      <button
        [hidden]="!showRunBatchReport"
        [disabled]="!showRunBatchReport"
        class="atlas-btn atlas-btn-primary mt-5"
        (click)="runBatchReportClicked()"
      >
        <span> {{ 'revenue.post-transactions.run-batch-report' | translate | uppercase }}</span>
      </button>
      <span class="ml-5">{{ nextBatchNumber }}</span>
    </div>
  </div>
</div>

<p-dialog modal="true" styleClass="atlas-dialog-xl" position="top" [closable]="false" [(visible)]="showEntryDetails">
  <wl-journal-entry-details
    (accountChanged)="transactionAccountChanged($event)"
    [accountChanges]="accountChanges"
    [searchQueryParams]="searchQueryParams"
    preventInitialLoad="true"
  ></wl-journal-entry-details>
  <ng-template #footer>
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" [disabled]="" (click)="showEntryDetails = false">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button
      pButton
      type="button"
      class="atlas-btn atlas-btn-primary"
      [disabled]="updateJournalEntryLoading"
      (click)="updateTransactionsClicked()"
    >
      <wl-busy [show]="updateJournalEntryLoading"></wl-busy>
      <span> {{ 'revenue.post-transactions.update-journal-entries' | translate | uppercase }}</span>
    </button>
  </ng-template>
</p-dialog>

<p-confirmDialog
  #cd
  key="postTransactionsCD"
  header="{{ 'revenue.post-transactions.title' | translate | titlecase }}"
  icon="pi pi-exclamation-triangle"
>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" (click)="cd.onReject()">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button pButton type="button" class="atlas-btn atlas-btn-primary" [disabled]="disablePostingConfirmation" (click)="cd.onAccept()">
      {{ 'revenue.post-transactions.title' | translate | uppercase }}
    </button>
  </ng-template>
</p-confirmDialog>
